import { render } from "./DeleteObject.vue?vue&type=template&id=17919e55&scoped=true"
import script from "./DeleteObject.vue?vue&type=script&lang=js"
export * from "./DeleteObject.vue?vue&type=script&lang=js"

import "./DeleteObject.vue?vue&type=style&index=0&id=17919e55&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17919e55"]])

export default __exports__